const front = {
    html: {
      title: "HTML5",
    },
    css: {
      title: "CSS3",
    },
    javascript: {
      title: "Javascript",
    },
    typescript: {
      title: "Typescript",
    },
    bootstrap: {
      title: "Bootstrap",
    },
    styled: {
      title: "Styled-Components",
    },
    react: {
      title: "React JS",
    },
    materialUI: {
      title: "Material UI",
    },
    tailwind: {
      title: "Tailwindcss",
    },
    redux: {
      title: "Redux e useContext",
    },
    api: {
      title: "React-Query",
    },
    zod: {
      title: "Zod",
    }
  }




  
const back = {
    php: {
        title: "PHP",
    },
    node: {
        title: "Node JS",
    },
    mysql: {
        title: "Mysql",
    },
    laravel: {
        title: "Laravel",
    },
    firebase: {
      title: "FireBase",
    },
    mongo: {
      title: "Mongo DB",
    },
  }

export const experiencesFront = [front.html, front.css, front.javascript,front.typescript, front.react, front.tailwind,  front.materialUI, front.bootstrap, front.styled, front.redux, front.api, front.zod]
export const experiencesBack = [back.node, back.php, back.mysql, back.laravel, back.firebase]